import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { appTheme } from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import SettingsPage from './pages/SettingsPage';
import CompaniesPage from './pages/CompaniesPage';
import PriceListPage from './pages/PriceListPage';
import DashboardPage from './pages/DashboardPage';
import EvaluationsListPage from './pages/EvaluationsListPage';
import EvaluationFormPage from './pages/EvaluationFormPage';
import EvaluationApprovalPage from './pages/EvaluationApprovalPage';
import NotificationsPage from './pages/NotificationsPage';
import ProtectedRoute from './components/ProtectedRoute';
import './utils/i18n';
import { getBuildVersion } from './utils/buildVersion';

const buildVersion = getBuildVersion();
if (typeof window !== 'undefined') {
  (window as unknown as { __APP_VERSION__?: string }).__APP_VERSION__ = buildVersion;
}

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <LanguageProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/evaluations" element={<EvaluationsListPage />} />
                        <Route path="/evaluations/:id" element={<EvaluationFormPage />} />
                        <Route path="/evaluations/:id/approve" element={<EvaluationApprovalPage />} />
                        <Route path="/companies" element={<CompaniesPage />} />
                        <Route path="/price-list" element={<PriceListPage />} />
                        <Route path="/notifications" element={<NotificationsPage />} />
                        <Route path="/settings" element={<SettingsPage />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
